// frontend/src/utils/shaping/resolveResponseShapingPolicy.js

const ANALYTICAL_RESPONSE_INTENTS = new Set([
  'INTEGRATE_EVIDENCE',
  'SUPPORT_DECISION',
  'CONTINUE_ACTIVE_INTENT',
  'CONTINUE_TOPIC',
  'CONTINUE_CONTEXT',
]);

function getStateType(value = null) {
  if (!value) return '';
  if (typeof value === 'string') return value.trim();
  return String(value.type || value.label || value.text || '').trim();
}

function resolveResponseShapingPolicy(context = {}) {
  const intentState = context.intentState || {};
  const arbitration = context.turnSignalArbitration || {};
  const frame = context.frame || {};
  const responseIntent =
    getStateType(context.responseIntent) ||
    getStateType(intentState.responseIntent) ||
    'ANSWER_NORMALLY';
  const dominantSignal = arbitration.dominantSignal || 'none';
  const emotionalScore = Number(arbitration?.scores?.emotionalDisclosure || 0);
  const legacyIntent = String(context.intent || '').toLowerCase();
  const frameType = String(frame.type || '').toLowerCase();

  const emotionalPresence =
    responseIntent === 'RESPOND_WITH_EMOTIONAL_PRESENCE' ||
    dominantSignal === 'emotionalDisclosure' ||
    emotionalScore >= 0.7 ||
    ['loss', 'grief', 'sadness', 'comfort'].includes(legacyIntent) ||
    ['loss', 'grief', 'bereavement'].includes(frameType);

  const grounding =
    emotionalPresence &&
    (legacyIntent === 'anxiety' || frameType === 'distress' || frameType === 'crisis');

  if (grounding) {
    return {
      mode: 'grounding',
      responseIntent,
      preserveRawReply: true,
      allowOptionalQuestion: true,
      questionAuthority: 'optional',
      requireReasoningAdvance: false,
      emotionalDepth: 'steady',
      relationshipCentered: false,
      avoidAmplification: true,
    };
  }

  if (emotionalPresence) {
    return {
      mode: 'emotional_presence',
      responseIntent,
      preserveRawReply: true,
      allowOptionalQuestion: true,
      questionAuthority: 'optional',
      requireReasoningAdvance: false,
      emotionalDepth: 'rich',
      relationshipCentered: true,
      avoidAmplification: false,
    };
  }

  if (ANALYTICAL_RESPONSE_INTENTS.has(responseIntent)) {
    return {
      mode: 'analytical_continuation',
      responseIntent,
      preserveRawReply: true,
      allowOptionalQuestion: false,
      questionAuthority: 'none',
      requireReasoningAdvance: true,
      emotionalDepth: 'low',
      relationshipCentered: false,
      avoidAmplification: false,
    };
  }

  if (responseIntent === 'HANDLE_PENDING_ANSWER') {
    return {
      mode: 'pending_answer',
      responseIntent,
      preserveRawReply: true,
      allowOptionalQuestion: false,
      questionAuthority: 'none',
      requireReasoningAdvance: false,
      emotionalDepth: 'normal',
      relationshipCentered: false,
      avoidAmplification: false,
    };
  }

  return {
    mode: 'normal',
    responseIntent,
    preserveRawReply: true,
    allowOptionalQuestion: null,
    questionAuthority: 'optional',
    requireReasoningAdvance: false,
    emotionalDepth: 'normal',
    relationshipCentered: false,
    avoidAmplification: false,
  };
}

export { resolveResponseShapingPolicy };
export default resolveResponseShapingPolicy;
